import {model} from './model'
import {App} from './classes/app'

import 'animate.css'
import 'magnific-popup'

//CSS
import './assets/libs/linea/styles.css'
import './assets/libs/font-awesome/css/font-awesome.min.css'
import './assets/styles/skins/blue.css'
import './assets/styles/fonts.css'
import './assets/styles/main.css'
import './assets/styles/style.css'
import './assets/styles/media.css'
//CSS


new App(model).init()